/* tslint:disable */

/**
 */
export class ProgressBar {
    BRAIN_PROCESS?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/progress-bar.ts